<template>
    <div class="bottomBox" v-if="!$store.state.isMobile">
        <!--        <topMenuHref ref="topMenuHref"/>-->
        <div class="top">
            <div class="nav">
                <img class="logo" src="@/assets/img/topMenu/topLogo_w.svg" alt="" @click="$router.replace('/')">
                <a href="https://www.facebook.com/efashionparis/"><img src="@/assets/img/bottom/Facebook.svg" alt="" class="icon"></a>
                <a href="https://twitter.com/efashionparis"><img src="@/assets/img/bottom/Twitter.svg" alt="" class="icon"></a>
                <a href="https://www.instagram.com/efashionparis_official/"><img src="@/assets/img/bottom/Instagram.svg" alt="" class="icon"></a>
                <h2>{{ langPage['v4-home-not-connected']['TXT_slogen'] }}</h2>
            </div>
        </div>
        <div class="divider"></div>
        <div class="lists">
            <ul>
                <li class="header">{{ langPage['landingpage']['TXT_nouscontacter'] }}</li>
                <li>{{ langPage['v4-bottombox']['TXT_numerotelephone'] }}</li>
                <li>{{ langPage['v4-bottombox']['TXT_emailadress'] }}</li>
                <li class="link" v-if="!isLogin">
                    <a :href="this.$common.addDomainUrl('/sign/signpage/buyer')">{{ langPage['l.general']['TXT_footdevenirmembre'] }}</a>
                </li>
                <li class="link" v-if="!isLogin">
                    <a :href="this.$common.addDomainUrl('/sign/signpage/seller')">{{ langPage['v4-inscription-grossistes']['TXT_devenirvendeur'] }}</a>
                </li>
            </ul>
            <ul>
                <li class="header">{{ langPage['bov-l.general']['TXT_catalogue'] }}</li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=11')">{{ langPage['bov-catalogue-shooting-planning']['TXT_femme'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=12')">{{ langPage['bov-catalogue-shooting-planning']['TXT_homme'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=1401')">{{ langPage['boa-communication-seocategories']['TXT_chaussures'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=13')">{{ langPage['boa-communication-seocategories']['TXT_enfant'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=15')">{{ langPage['boa-communication-seocategories']['TXT_maroquinerie'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=16')">{{ langPage['boa-vendeurs-liste-demande-fiche']['TXT_accessoire'] }}
                    </a>
                </li>
            </ul>
            <ul>
                <li class="header">{{ langPage['boa-manager-shooting-data-liste']['TXT_infos'] }}</li>
                <li>
                    <a :href="this.$common.addDomainUrl('/about')">{{ langPage['pages-menu']['TXT_apropos'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/help')">{{ langPage['compte-commandes-liste']['TXT_aide'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/help?questionIndex=3')">{{ langPage['v4-bottombox']['TXT_livraisonetcommande'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/help?questionIndex=5')">{{ langPage['v4-bottombox']['TXT_retoursetechanges'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/conditions/contact')">{{ langPage['landingpage']['TXT_nouscontacter'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/conditions/commonPage?type=cguv')">{{ langPage['v4-bottombox']['TXT_conditions'] }}</a>
                </li>
            </ul>
            <ul>
                <li class="appLogo">
                    <a href="https://apps.apple.com/fr/app/efashion-paris/id1460584296">
                        <img src="@/assets/img/bottom/apple-store-badge.png" alt=""/>
                    </a>
                </li>
                <li class="appLogo">
                    <a href="https://play.google.com/store/apps/details?id=com.efashionparis&gl=FR">
                        <img src="@/assets/img/bottom/Google_Play_2015.png" alt=""/>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div v-else>
        <el-col class="mBottomBox" align="center">
            <div><img class="logo" src="@/assets/img/topMenu/topLogo_w.svg" alt="" @click="$router.replace('/')"></div>
            <a href="https://www.facebook.com/efashionparis/"><img src="@/assets/img/bottom/Facebook.svg" alt="" class="icon"></a>
            <a href="https://twitter.com/efashionparis"><img src="@/assets/img/bottom/Twitter.svg" alt="" class="icon"></a>
            <a href="https://www.instagram.com/efashionparis_official/"><img src="@/assets/img/bottom/Instagram.svg" alt="" class="icon"></a>
            <div class="laPremBox">
                <h2>{{ langPage['v4-home-not-connected']['TXT_slogen'] }}</h2>
            </div>
            <ul>
                <li class="header">{{ langPage['landingpage']['TXT_nouscontacter'] }}</li>
                <li class="bottomRouterLink">{{ langPage['v4-bottombox']['TXT_numerotelephone'] }}</li>
                <li class="bottomRouterLink">{{ langPage['v4-bottombox']['TXT_emailadress'] }}</li>
                <li class="link" v-if="!isLogin">
                    <a :href="this.$common.addDomainUrl('/sign/signpage/buyer')">{{ langPage['l.general']['TXT_footdevenirmembre'] }}</a>
                </li>
                <li class="link" v-if="!isLogin">
                    <a :href="this.$common.addDomainUrl('/sign/signpage/seller')">Devenir vendeur</a>
                </li>
            </ul>
            <ul>
                <li class="header">{{ langPage['bov-l.general']['TXT_catalogue'] }}</li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=11')">{{ langPage['bov-catalogue-shooting-planning']['TXT_femme'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=12')">{{ langPage['bov-catalogue-shooting-planning']['TXT_homme'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=1401')">{{ langPage['boa-communication-seocategories']['TXT_chaussures'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=13')">{{ langPage['boa-communication-seocategories']['TXT_enfant'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=15')">{{ langPage['boa-communication-seocategories']['TXT_maroquinerie'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/productList?id=16')">{{ langPage['boa-vendeurs-liste-demande-fiche']['TXT_accessoire'] }}
                    </a>
                </li>
            </ul>
            <ul>
                <li class="header">{{ langPage['boa-manager-shooting-data-liste']['TXT_infos'] }}</li>
                <li>
                    <a :href="this.$common.addDomainUrl('/about')">{{ langPage['pages-menu']['TXT_apropos'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/help')">{{ langPage['compte-commandes-liste']['TXT_aide'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/help?questionIndex=3')">{{ langPage['v4-bottombox']['TXT_livraisonetcommande'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/help?questionIndex=5')">{{ langPage['v4-bottombox']['TXT_retoursetechanges'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/conditions/contact')">{{ langPage['landingpage']['TXT_nouscontacter'] }}</a>
                </li>
                <li>
                    <a :href="this.$common.addDomainUrl('/conditions/commonPage?type=cguv')">{{ langPage['v4-bottombox']['TXT_conditions'] }}</a>
                </li>
            </ul>
            <ul>
                <li class="appLogo">
                    <a href="https://apps.apple.com/fr/app/efashion-paris/id1460584296">
                        <img src="@/assets/img/bottom/apple-store-badge.png" alt=""/>
                    </a>
                </li>
                <li class="appLogo">
                    <a href="https://play.google.com/store/apps/details?id=com.efashionparis&gl=FR">
                        <img src="@/assets/img/bottom/Google_Play_2015.png" alt=""/>
                    </a>
                </li>
            </ul>
        </el-col>
    </div>
</template>

<script>

import topMenuHref from "@/components/topMenuHref";

export default {
    name: "bottomBox",
    props: {
        loginFlag: Boolean
    },
    components: {topMenuHref},
    computed: {
        isLogin() {
            return localStorage.getItem('token') ? true : false
        },
        langPage() {
            return this.$store.state['langPage']
        }
    },
}
</script>

<style scoped lang="less">
p {
    color: #F6F3F1;
}

a {
    color: #F6F3F1;
}

li {
    color: #F6F3F1;
}

.bottomBox {
    background: #000000;
    padding: 20px 1rem;
    width: 100%;

    .top {
        height: .4rem;
        line-height: .4rem;
        text-align: left;
        vertical-align: middle;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .nav {
            .logo {
                width: 155px;
                vertical-align: middle;
                margin-right: 82px;
                cursor: pointer;
            }

            .icon {
                width: 15px;
                vertical-align: middle;
                margin-right: 20px;
            }

            h2 {
                height: .4rem;
                line-height: .4rem;
                display: inline-block;
                color: #F6F3F1;
                font-family: Ogg-Roman;
                margin-left: 78px;
                font-size: 24px;
            }
        }


    }

    .divider {
        height: 1px;
        width: 100%;
        background: white;
        opacity: 0.1;
        margin: 43px 0 48px 0;
    }

    .lists {
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        ul {
            color: #FFFFFF;
            text-align: left;

            li {
                font-size: 14px;
                font-family: MaisonNeue-Light;
                height: 30px;
                line-height: 30px;

                &.header {
                    font-family: MaisonNeue-Medium;
                    font-size: 14px;
                    text-transform: uppercase;
                }

                a {
                    color: #FFFFFF;
                    height: 30px;
                    line-height: 30px;
                }

                &.link {
                    height: 30px;
                    margin-top: 15px;

                    a {
                        color: #FFFFFF;
                        border: 1px solid #FFFFFF;
                        width: 100%;
                        text-align: center;
                        line-height: 30px;
                        font-size: 16px;
                        box-sizing: border-box;
                        padding: 0 10px;
                    }
                }

                &.appLogo {
                    height: auto;
                    margin-bottom: 20px;
                }

            }
        }
    }

}

.mBottomBox {
    background: #000000;
    padding: 16vw 4vw;
    width: 100%;
    position: relative;
    justify-content: center;
    color: white;

    .logo {
        width: 41vw;
        cursor: pointer;
    }

    .icon {
        margin-right: 3vw;
        margin-top: 10vw;
        width: 4.2vw;
    }

    .laPremBox {
        display: block;
        margin-top: 8.5vw;
        margin-bottom: 20vw;
    }

    h2 {
        margin-top: 8.5vw;
        font-family: Ogg-Roman;
        font-size: 6.4vw;
        font-weight: 400;
        line-height: 8.5vw;
        letter-spacing: 0.05em;
        text-align: center;

        color: #F6F3F1;
        display: inline;
    }

    .divider {
        height: 1px;
        width: 100%;
        background: white;
        opacity: 0.1;
        margin: 43px 0 48px 0;
    }

    ul {
        margin-top: 5vw;

        li {
            color: white;

            &.header {
                font-family: MaisonNeue-Medium;
                font-size: 3.3vw;
                margin-bottom: 5vw;
                text-transform: uppercase;
            }

            a {
                color: #FFFFFF;
                height: 30px;
                line-height: 30px;
                margin-bottom: 5vw;
                font-size: 3.3vw;
            }

            &.link {
                a {
                    color: #FFFFFF;
                    border: 1px solid #FFFFFF;
                    padding: 2.5vw 8vw;
                    text-align: center;
                    font-size: 3.8vw;
                }
            }

            &.appLogo {
                height: auto;
                margin-bottom: 8vw;
            }
        }
    }

    .bottomRouterLink {
        font-size: 3.3vw;
        margin-bottom: 26px;
    }
}
</style>
